export default class NavigateToUrl {
  constructor(context) {
    this.context = context;
  }

  run(url) {
    this.context.router.navigateToUrl(url);
  }
}
